import React, {memo} from 'react';

function Span({string, children, ...props}) {
    return (
        <span {...props}>{string || children}</span>
    )
}

export default memo(Span);